module.exports = __webpack_public_path__ + "static/img/zbbl1-5.0197f74.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/zbbl1-5.png
// module id = 816
// module chunks = 0